import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { setLastPath } from "../helpers";

export const PrivateRoute = () => {
  const { activeUsuario } = useSelector((state) => state.auth);
  const location = useLocation();
  // Guarda la última ruta visitada
  setLastPath(location.pathname);
  // Si no hay usuario activo, redirige al login
  if (!activeUsuario) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
